import React from 'react';
import PropTypes from 'prop-types';

const FundamentalPreview = ({ imageUrl, graphicType, graphicOption }) => (
  <div className='fundamental-preview'>
    <div className='preview-inner'>
      <img src={imageUrl} alt={`${graphicType} | ${graphicOption}`} />
    </div>
  </div>
);

FundamentalPreview.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  graphicType: PropTypes.string.isRequired,
  graphicOption: PropTypes.string.isRequired
};

export default FundamentalPreview;
